import React from "react";
import { Card } from "react-bootstrap";
import PropTypes from "prop-types";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";

const GreetingsWidget = function ({ statusWidgetData, widgetId, handleWidgetDialogOpen, isLayoutLocked, isPreview }) {
  const { widgets } = statusWidgetData;
  let completeQuoteRequest = "";
  let completeShipment = "";

  if (widgets?.length) {
    widgets.forEach((item) => {
      if (item.label === "Open quote requests") {
        completeQuoteRequest = new Intl.NumberFormat("en-IN", {}).format(item.value).toString();
      } else if (item.label === "Delivered Shipments") {
        completeShipment = new Intl.NumberFormat("en-IN", {}).format(item.value).toString();
      }
    });
  }

  return (
    <Card.Body className="d-flex align-items-center">
      {!isLayoutLocked && !isPreview && (
        <FontAwesomeIcon
          icon={faEllipsisV}
          className="position-absolute text-secondary font-16 cursor-pointer "
          style={{ top: 15, right: 15 }}
          onClick={() => handleWidgetDialogOpen(widgetId)}
        />
      )}
      <p className="mb-0 pr-3">
        <FormattedMessage
          id="dashboard.widgets.greeting1"
          defaultMessage="Hi {first_name}, since yesterday, you completed "
          values={{ first_name: statusWidgetData?.first_name }}
        />
        <span className="font-weight-bold">
          <FormattedMessage
            id="dashboard.widgets.greeting2"
            defaultMessage="{completeQuoteRequest} quote requests & "
            values={{ completeQuoteRequest }}
          />
        </span>
        <span className="font-weight-bold">
          <FormattedMessage
            id="dashboard.widgets.greeting3"
            defaultMessage="{completeShipment} shipments "
            values={{ completeShipment }}
          />
        </span>
        <FormattedMessage id="dashboard.widgets.greeting4" defaultMessage="have been delivered." />
      </p>
    </Card.Body>
  );
};

GreetingsWidget.propTypes = {
  statusWidgetData: PropTypes.instanceOf(Object).isRequired,
  widgetId: PropTypes.number,
  isLayoutLocked: PropTypes.bool,
  isPreview: PropTypes.bool,
  handleWidgetDialogOpen: PropTypes.func,
};

GreetingsWidget.defaultProps = {
  isLayoutLocked: false,
  isPreview: false,
  widgetId: null,
  handleWidgetDialogOpen: () => {},
};

export default GreetingsWidget;
